// extracted by mini-css-extract-plugin
export default {"politica":"politicas_politica__679F7"};